<template>
<div class="news-card" @mouseover="onMouseOverNews" @mouseleave="onMouseLeaveNews">
    <router-link :to="`/articles/${content.id || content.ID}`" class="news-card__link">
    <div class="news-card__image">
        <!-- <img class="news-card__image__elem" :src="content.acf.preview_image.url" :alt="content.acf.preview_image.alt"> -->
        <AppLazyImg :alt="content.acf.preview_image.alt" :url="content.acf.preview_image.sizes.medium" :width="content.acf.preview_image.sizes['medium-width']" :height="content.acf.preview_image.sizes['medium-height']" :classes="['news-card__image__elem']" forcedRatio="100" :hasMask="false" />
    </div>
    <div class="news-card__overlay">
        <div class="news-card__overlay__inner">
            <p class="news-card__overlay__text" v-html="content.acf.description"></p>
        </div>
    </div>
    <div class="news-card__content">
        <p v-if="hasDate" class="news-card__date" v-html="content.acf.date"></p>
        <h3 class="news-card__title" v-html="content.acf.displayed_title"></h3>
    </div>
    </router-link>
</div>
</template>

<script>

import AppLazyImg from '@/components/AppLazyImg.vue'

export default {
    name: 'AppNewsCard',

    components: {
        AppLazyImg
    },

    props: {
        content: {
            type: Object,
            default: null
        },

        hasDate: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {

        }
    },

    created()
    {

    },

    methods: {
        onMouseOverNews()
        {
            this.$el.classList.add('is-hover')
        },

        onMouseLeaveNews()
        {
            this.$el.classList.remove('is-hover')
        }
    }
}
</script>

<style lang="stylus" scoped>

.news-card
    display block

.news-card__link
    position relative
    display block
    overflow hidden

.news-card__image
    position relative
    width 100%
    margin-bottom 40px

    // &:before
    //     content ''
    //     display block
    //     padding-top 100%

.news-card__overlay
    position absolute
    bottom 0
    left 0
    width 100%
    height 75%
    background $white
    overflow hidden
    visibility hidden
    transform translateY(100%)
    transition transform 0.4s $ease-out-circ, visibility 0.4s

    .is-hover &
        visibility visible
        transform translateY(0)
        transition transform 0.8s $ease-out-circ

.news-card__overlay__inner
    width 100%
    height 100%
    visibility hidden
    transform translateY(-100%)
    transition transform 0.4s $ease-out-circ, visibility 0.4s

    .is-hover &
        visibility visible
        transform translateY(0)
        transition transform 0.8s $ease-out-circ

.news-card__overlay__text
    height 35%
    overflow hidden
    padding 35px 20px 0px 20px
    -webkit-line-clamp 3
    interpolate('font-size', 1600px, 2560px, 20px, 30px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

.news-card__content
    z-index 3
    position relative

.news-card__image__elem
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    object-fit cover

.news-card__date
    margin-bottom 20px
    padding-left 15px
    // font-size 15px
    line-height 1
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

.news-card-all
    position relative
    width 50%
    display flex
    flex-wrap wrap

.news-card__title
    padding-left 15px
    padding-right 15px
    padding-bottom 15px
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 15px, 25px);
</style>